export const useHomeworkPending = () => {}